module.exports = __webpack_public_path__ + "img/Terrain_Digging_Simulator-1.f971dc92.png";